import { FormControl, styled } from "@mui/material"

export const DateRangeFormControl = styled(FormControl)(({ theme }) => ({
  flex: 1,
  maxWidth: 180,
  minWidth: 120,
  "& .MuiInputBase-root": {
    BorderLeft: 0,
    borderRadius: "8px !important",
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: "100%",
  },
}))
